import forEach from 'lodash/forEach';

export const getConfiguredSizePaper = (optionVariants: any, optionType: string) => {
  const sizes = new Set();
  const papers = new Set();

  forEach(optionVariants, (variant) => {
    const { optionVariantValues } = variant;
    forEach(optionVariantValues, (value) => {
      const { type, name } = value;
      if (type === 'SIZE') {
        sizes.add(name);
      }

      if (type === optionType) {
        papers.add(name);
      }
    });
  });

  return { sizes: Array.from(sizes), papers: Array.from(papers) };
};
